/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_PRODUCTS = gql`
    query GetProducts {
        getProducts {
            count
            data {
                _id
                name
                description
                subtitle
                images
                desc {
                    lang
                    val
                    desc_type
                }
                website
                assets {
                    imgs {
                        height
                        src
                        width
                        asset_type
                    }
                    others {
                        src
                        width
                        asset_type
                        height
                    }
                }
            }
        }
    }
`;
